import { Map, View, Feature } from "ol";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import { Vector as SourceVector, OSM } from "ol/source";
import { Vector as LayerVector, Tile as TileLayer } from "ol/layer";
import { Icon, Style } from "ol/style";
import { defaults } from "ol/interaction";

const ThemeMap = {
  map: null,

  /**
   *
   * @param {HTMLDivElement} domElement
   */
  init(domElement, extra = "") {
    const mapEl = $(domElement);

    const location = fromLonLat([mapEl.data("lng"), mapEl.data("lat")]);

    // Custom marker
    let vectorLayer = this.createMarker(location);

    let rasterLayer = new TileLayer({
      source: new OSM(),
    });

    // Map
    this.map = new Map({
      target: domElement,
      view: new View({
        center: location,
        zoom: mapEl.data("zoom"),
      }),
      interactions: defaults({
        mouseWheelZoom: false,
        dragPan: false,
      }),
      layers: [rasterLayer, vectorLayer],
    });

    if ("offset" == extra) {
      let center = this.map.getView().getCenter();
      let resolution = this.map.getView().getResolution();
      this.map.getView().setCenter([center[0] + 200 * resolution, center[1]]);
    }
  },

  createMarker(location) {
    let iconFeature = new Feature({
      geometry: new Point(location),
    });

    let style = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        scale: 0.9,
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: baseurl + "/src/img/icon-pin.svg",
      }),
    });

    iconFeature.setStyle(style);

    let vectorSource = new SourceVector({
      features: [iconFeature],
    });

    return new LayerVector({
      source: vectorSource,
    });
  },
};

export default ThemeMap;
